import Vuex from 'vuex'

import LoginModule from './login'
import UserModule from './user'
import RegisterModule from './registration'
import PanelModule from './panel'
import HomeModule  from './home'
import ItemShopModule  from './itemShop'
import RankingModule from './ranking'
import AuctionModule from './auction'
import ForgotPassowrd from './forgotpassword'

const state = {}
const actions = ({})
const mutations = ({})
const getters = ({})

const modules = {
    login: LoginModule,
    user: UserModule,
    register: RegisterModule,
    panel: PanelModule,
    home: HomeModule,
    itemShop: ItemShopModule,
    ranking: RankingModule,
    auction: AuctionModule,
    forgotPassword: ForgotPassowrd
  }

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules
})